"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// @ts-ignore Instead of using the DOM lib, we ignore the Typescript errors here.
const isBrowser = !!(
// Extremely silly but we need "true &&" or prettier moves our @ts-ignore to the wrong location
(true &&
    // @ts-ignore
    typeof window !== "undefined" &&
    // @ts-ignore
    window.document &&
    // @ts-ignore
    window.document.createElement));
/**
 * An isomorphic method, which when used in the browser allows you to pass an image URL and does
 * not return it until it has loaded.
 */
const useLoadedUrl = isBrowser ? useLoadedUrlBrowser : useLoadedUrlServer;
exports.default = useLoadedUrl;
function useLoadedUrlServer(url) {
    return url;
}
function useLoadedUrlBrowser(url, { onError: onErrorCallback, retries = 0, retryDelayMs = 1000, } = {}) {
    const [loadedUrl, setLoadedUrl] = (0, react_1.useState)();
    const [retryNumber, setRetryNumber] = (0, react_1.useState)(0);
    const [retryTimerId, setRetryTimerId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        return () => {
            // @ts-ignore
            retryTimerId && window.clearTimeout(retryTimerId);
        };
    }, [retryTimerId]);
    (0, react_1.useEffect)(() => {
        if (!url) {
            return;
        }
        // @ts-ignore
        const imageLoader = new Image();
        imageLoader.onload = onLoad;
        imageLoader.onerror = onError;
        imageLoader.src = url;
        function onLoad() {
            setLoadedUrl(url);
        }
        function onError() {
            if (retryNumber < retries) {
                // @ts-ignore
                const timerId = window.setTimeout(() => {
                    setRetryNumber(retryNumber + 1);
                }, retryDelayMs * retryNumber /* Simple "exponential" back off. */);
                setRetryTimerId(timerId);
            }
            else {
                // Maxed out our retries. Let's give up.
                setLoadedUrl(undefined);
                onErrorCallback && onErrorCallback(url);
            }
        }
        return () => {
            imageLoader.onload = null;
            imageLoader.onerror = null;
        };
    }, [url, setLoadedUrl, retryNumber]);
    return loadedUrl;
}
//# sourceMappingURL=data:application/json;base64,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